module.exports = __webpack_public_path__ + "static/img/2.bdf37b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/2.png
// module id = Wmov
// module chunks = 0